import { useQuery } from "@tanstack/react-query";
import businessCustomerService from "../../services/businessCustomer/businessCustomer.service";

// 0016: the SINGLE fetch of the admin business-customer list (/BusinessCustomer/List — ~39KB, the
// heaviest shared list, hit by the agent-assignment dialog + the business-account add dialog). React
// Query dedups N consumers + the StrictMode double-mount to ONE network call. The data is read-only
// (Rivhit-synced; the frontend never creates/edits/deletes a business customer), so staleTime 5min
// means re-opening either dialog does not refetch — and there is no refresh-after-mutation concern.
const useBusinessCustomerListQuery = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: ["businessCustomers", "all"],
    queryFn: () => businessCustomerService.getBusinessCustomerList().then((r) => r.data.payload),
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

export default useBusinessCustomerListQuery;
